module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_access_05-d37ee525e53b03e3b409446fad77f8db.jpg";